<template>
  <div v-html="value"></div>
</template>
<script>
import base from "matrix.node.ui/field.js";
export default {
  mixins: [base.view(String)]
};
</script>